var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('u-header',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('action-form',{key:_vm.$route.path,attrs:{"channel-code":_vm.emailNotifationChannel,"notification-template-id":_vm.templateId,"return-to":{
        name: 'adminEmailTemplates'
      }}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }